<template>
  <section
    id="app"
    class="hero is-fullheight"
    :style="{ backgroundImage: `url(${backgroundUrl})` }"
  >
    <a class="logo-nav">
      <img class="logo" :src="logoUrl" alt="Zul Digital" />
    </a>
    <div class="hero-title">
      <h1 class="title">
        <span class="is-blue">Zul</span>
        <span class="is-blue">Digital</span>
        <span class="is-white">Corp</span>
      </h1>
      <p class="subtitle">Estacionamento Rotativo Digital</p>
    </div>
    <div class="hero-body">
      <b-loading :is-full-page="isFullPage" :active.sync="isLoading" />
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-half"></div>
          <div class="column is-half">
            <div class="columns is-centered">
              <div class="column is-8-desktop">
                <h1 class="title">Acesse sua conta</h1>
                <h2 class="subtitle">ou
                  <router-link to="/cadastrar">cadastre-se</router-link>
                </h2>

                <p v-if="user.city">
                  <a
                    :href="`http://static.zuldigital.com.br/corp/${pdfPath}/Zul%20Digital%20-%20Frotistas.pdf`"
                    class="is-white"
                    style="text-decoration: underline"
                    target="_blank"
                  >
                    <span style=""
                      >Entenda como funciona a conta corporativa.</span
                    >
                    <b-icon
                      style="display: inline-block; transform: translateY(0.25em) translateX(0.25em);"
                      icon="external-link-alt"
                      size="is-small"
                    >
                    </b-icon>
                  </a>
                </p>
                <p><br /></p>
                <form @submit="validateAndSubmit">


                  <b-field
                    :type="{ 'is-danger': errors.has('city') }"
                    :message="errors.first('city')"
                  >
                    <b-select
                      name="city"
                      placeholder="Selecione a cidade"
                      expanded
                      v-model="user.city"
                      v-validate="'required'"
                      data-vv-as="cidade"
                    >
                      <option value="">Selecione a cidade...</option>
                      <option
                        v-for="option in cities"
                        :value="option.value"
                        :key="option.value"
                      >
                        {{ option.title }}
                      </option>
                    </b-select>
                  </b-field>
                  <b-field
                    :type="{ 'is-danger': errors.has('document') }"
                    :message="errors.first('document')"
                    v-if="user.city"
                  >
                    <b-input
                      name="document"
                      v-model="user.document"
                      placeholder="CNPJ"
                      v-validate="'required|document'"
                      data-vv-as="CNPJ"
                      v-cleave="masks.CNPJ"
                      @input.native="cleaveRefresh"
                    />
                  </b-field>
                  <b-field
                    :type="{ 'is-danger': errors.has('password') }"
                    :message="errors.first('password')"
                    v-if="user.city"
                  >
                    <b-input
                      name="password"
                      v-model="user.password"
                      type="password"
                      placeholder="Senha"
                      password-reveal
                      @keyup.enter.native="login"
                      v-validate="'required'"
                      data-vv-as="senha"
                    />
                  </b-field>
                  <div class="columns is-mobile" v-if="user.city">
                    <div class="column is-4">
                      <b-field grouped>
                        <div class="control">
                          <b-button
                            type="is-primary"
                            @click.prevent="validateAndSubmit"
                            >Login</b-button
                          >
                        </div>
                        <div class="control">
                          <!-- <router-link to="/forgot-password" class="button is-text"
                          >Esqueci minha senha</router-link
                        > -->
                        </div>
                      </b-field>
                    </div>
                    <div class="column">
                      <p class="has-text-right">
                        <b-tooltip
                          label="Caso não se recorde da senha associada ao seu cadastro, utilize o aplicativo para fazer o resgate."
                          position="is-bottom"
                          multilined
                          style="cursor: pointer"
                        >
                          <span class="is-white">Esqueci minha senha</span>
                          <b-icon
                            style="
                              margin-bottom: -0.75em;
                              display: inline-block;
                              margin-left: 0.75em;
                            "
                            icon="info-circle"
                            type="is-white"
                          >
                          </b-icon>
                        </b-tooltip>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <OTPValidation
      :maskedPhoneNumber="maskedPhoneNumber"
      :userData="rawUserData"
      v-show="isOTPModalVisible"
      ref="otpValidation"
      @close="closeOTPModal"
    >
    </OTPValidation>
    <AccessValidation
      v-show="isAccessValidatinModalVisible"
      :info="accessValidationInfo"
      @confirm="tryLoginAgain"
    ></AccessValidation>
  </section>
</template>

<script>
import { getIdentifierHeaders } from "@zuldigital/utils";
import { cities } from "../../services/cityUtils";
import cleave, { cleaveRefresh, masks } from "../../directives/cleave.js";
import logoImage from "../../assets/images/logo.svg";
import background from "../../assets/images/login-bg.jpg";
import signup from "../../services/signup";
import OTPValidation from "../../components/OTPValidation";
import AccessValidation from "../../components/AccessValidation";

export default {
  components: {
    OTPValidation,
    AccessValidation,
  },
  data() {
    return {
      isAccessValidatinModalVisible: false,
      accessValidationInfo: {},
      rawUserData: {},
      pinModel: "",
      maskedPhoneNumber: "",
      isOTPModalVisible: false,
      masks,
      cleaveRefresh,
      isFullPage: true,
      isLoading: false,
      user: {
        city: null,
        document: null,
        password: null,
        scope: "ROLE_CORPORATE_MASTER",
      },
      cities: cities,
    };
  },
  directives: {
    cleave,
  },
  computed: {
    logoUrl() {
      return logoImage;
    },
    backgroundUrl() {
      return background;
    },
    pdfPath() {
      if (this.user && this.user.city) {
        const cityChosen = this.cities.filter(v => v.value == this.user.city)
        return cityChosen && cityChosen[0] ? cityChosen[0].pdfPath : this.user.city.toLowerCase();
      }
      return 'estapar'
    }
  },
  mounted() {
    const storedCity = localStorage.getItem("X-City");
    const { city: querystringCity, document: querystringDocument } =
      this.$route.query;

    this.user.city = querystringCity || storedCity;
    this.user.document = querystringDocument || null;
  },
  methods: {
    showOTPModal() {
      this.isOTPModalVisible = true;
    },
    closeOTPModal() {
      this.$nextTick(() => {
        this.isOTPModalVisible = false;
      });
    },
    validateAndSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          return this.login();
        }
        this.$buefy.toast.open({
          message: "Verfique os campos marcados para continuar.",
          type: "is-danger",
        });
      });
    },
    tryLoginAgain() {
      this.isAccessValidatinModalVisible = false;
      this.login();
    },
    login() {
      const rawData = Object.assign({}, this.user);

      // cleaning document puntification
      rawData.document = rawData.document.replace(/[^\d]/g, "");

      this.rawUserData = rawData;

      const data = Object.keys(rawData)
        .map((key) => `${key}=${rawData[key]}`)
        .join("&");

      this.isLoading = true;
      localStorage.setItem("X-City", this.user.city);
      this.$auth.login({
        data,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-City": rawData.city,
          ...getIdentifierHeaders(),
        },
        success() {},
        error(err) {
          this.isLoading = false;
          if (err && err.response) {
            const {
              response: { headers },
            } = err;
            let message = "";
            switch (err.response.status) {
              case 400:
                message = "Não foram enviados dados obrigatórios.";
                break;
              case 406:
                message = "Dados de acesso incorretos.";
                break;
              case 411:
                setTimeout(() => {
                  this.isAccessValidatinModalVisible = true;
                }, 150);

                this.accessValidationInfo =
                  (err.response.data || {}).data || {};
                break;
              case 417:
                message =
                  "Ocorreu um erro de sistema ao tentar efetuar o acesso.";

                if (headers["x-auth-token"]) {
                  this.$auth.token("access_token", headers["x-auth-token"]);

                  // Token
                  return signup
                    .signup()
                    .then(() => {
                      this.login()
                    })
                    .catch(() => {
                      this.$buefy.toast.open({
                        message: message,
                        type: "is-danger",
                      });
                    });
                }

                break;
              case 426:
                this.maskedPhoneNumber = (
                  (err.response.data || {}).data || {}
                ).maskedPhoneNumber;
                this.$refs.otpValidation.checkStep(this.maskedPhoneNumber);
                setTimeout(() => {
                  this.showOTPModal();
                }, 150);
                break;
              default:
                message =
                  "Ocorreu um erro de sistema ao tentar efetuar o acesso.";
                break;
            }

            if (message) {
              this.$buefy.toast.open({
                message: message,
                type: "is-danger",
              });
            }
          } else {
            this.$buefy.toast.open({
              message:
                "Ocorreu um erro inesperado, Por favor tente novamente em instantes",
              type: "is-danger",
            });
          }
        },
        rememberMe: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_variables.scss";

#app {
  background: $black;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;

  .is-blue {
    color: $blue;
  }
  .is-white {
    color: $white;
  }
}

.logo-nav {
  top: 100px;
  left: calc(100vw / 2 - 50px);
  position: fixed;

  @include desktop {
    top: 100px;
    left: 120px;
  }
}

.logo {
  height: 100px;
  width: 100px;
}

.title {
  font-weight: 900;

  > span {
    display: block;
  }
}

.hero-title {
  display: none;
  left: 24px;
  position: fixed;
  top: 50px;

  .title {
    font-size: 36px;
  }
  .subtitle {
    color: $white;
    font-size: 16px;
  }

  @include desktop {
    bottom: 100px;
    display: block;
    left: 120px;
    top: auto;

    .title {
      font-size: 72px;
    }

    .subtitle {
      font-size: 26px;
      margin-top: 30px;
    }
  }
}

  h1, h2, h2 > a {
    color: #fff;
  }

  h2 > a  {
    text-decoration: underline;
  }
</style>
